export default __webpack_public_path__ + "static/gibkaya-cherepica-d9f23b21b8995d944470860253117149.jpg";